import { getAngleByTime } from "@/utils/functions/getAngleByTime";
import React from "react";

const TimeIndicator = ({ time, isEntry }) => {
  const angle = getAngleByTime(time);
  const activeColor = isEntry ? "#00B078" : "#ef4444";

  return (
    <div className="flex  items-center lg:p-4 p-2 bg-[#E7EDF4] bg-opacity-50 rounded-custom-10 flex-1">
      <div className="relative w-[122px] h-[122px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 123 123"
          className="w-full h-full"
        >
          {/* İç daire */}
          <circle
            cx="61.3921"
            cy="61.3926"
            r="41.6607"
            fill="transparent"
            stroke={activeColor}
            strokeWidth="2.8"
          />
          <mask id="progress-mask" fill="white">
            <path d="M104.283 54.691C105.871 64.856 103.798 75.2548 98.4319 84.0332C93.0661 92.8116 84.7569 99.3989 74.9859 102.621C65.2149 105.842 54.6173 105.489 45.0826 101.623C35.5479 97.758 27.696 90.6318 22.9268 81.5155C18.1577 72.3992 16.7814 61.8853 19.0433 51.8486C21.3053 41.8119 27.0583 32.9048 35.2768 26.7154C43.4953 20.526 53.6449 17.4568 63.9159 18.0549C74.187 18.6529 83.9117 22.8795 91.3563 29.981L88.9412 32.5128C82.0967 25.9837 73.1557 22.0978 63.7125 21.5479C54.2694 20.998 44.9378 23.8199 37.3818 29.5104C29.8257 35.2009 24.5363 43.3901 22.4567 52.6179C20.3771 61.8456 21.6425 71.512 26.0272 79.8936C30.4119 88.2751 37.631 94.8269 46.3972 98.3808C55.1633 101.935 64.9068 102.26 73.8903 99.2975C82.8737 96.3355 90.5132 90.2792 95.4465 82.2084C100.38 74.1375 102.286 64.5769 100.826 55.2311L104.283 54.691Z" />
          </mask>
          <path
            d="M104.283 54.691C105.871 64.856 103.798 75.2548 98.4319 84.0332C93.0661 92.8116 84.7569 99.3989 74.9859 102.621C65.2149 105.842 54.6173 105.489 45.0826 101.623C35.5479 97.758 27.696 90.6318 22.9268 81.5155C18.1577 72.3992 16.7814 61.8853 19.0433 51.8486C21.3053 41.8119 27.0583 32.9048 35.2768 26.7154C43.4953 20.526 53.6449 17.4568 63.9159 18.0549C74.187 18.6529 83.9117 22.8795 91.3563 29.981L88.9412 32.5128C82.0967 25.9837 73.1557 22.0978 63.7125 21.5479C54.2694 20.998 44.9378 23.8199 37.3818 29.5104C29.8257 35.2009 24.5363 43.3901 22.4567 52.6179C20.3771 61.8456 21.6425 71.512 26.0272 79.8936C30.4119 88.2751 37.631 94.8269 46.3972 98.3808C55.1633 101.935 64.9068 102.26 73.8903 99.2975C82.8737 96.3355 90.5132 90.2792 95.4465 82.2084C100.38 74.1375 102.286 64.5769 100.826 55.2311L104.283 54.691Z"
            stroke="#D2D9E2"
            strokeWidth="7.0018"
            mask="url(#progress-mask)"
            style={{
              transformOrigin: "center",
              transform: `rotate(${angle - 60}deg)`,
            }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span
            className="text-base font-semibold leading-normal"
            style={{ color: activeColor }}
          >
            {time}
          </span>
        </div>
      </div>
      <div className="flex flex-col">
        <span className="text-base font-semibold leading-normal text-black">
          {isEntry ? "Giriş saati" : "Çıkış saati"}
        </span>
        <span className="text-sm font-normal leading-normal text-black">
          {isEntry
            ? "En erken giriş yapabileceğin saati belirtir"
            : "En erken çıkış yapabileceğin saati belirtir"}
        </span>
      </div>
    </div>
  );
};

export default TimeIndicator;
